import { Components, Theme } from "@mui/material";

declare module "@mui/material/Divider" {}

export const MuiDivider: Components<Theme>["MuiDivider"] = {
  styleOverrides: {
    root: {
      margin: "1rem 0",
    },
  },
};
